/**
 * @desc 仓库绩效报表
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(
  params: API.wms.inoutStepRecord.warehousePerformance.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/inoutStepRecord/warehousePerformance`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
